import { create } from 'zustand';

export const FACILITY_JOURNEY = [
  {
    site: 'wallops-cdas',
    room: null,
    title: 'Receive at Wallops',
    text: 'The antenna field provides the space-to-ground RF interface. Start with the campus, then follow the illustrative receive chain.',
  },
  {
    site: 'wallops-cdas',
    room: 'room_receive',
    title: 'Recover the data',
    text: 'Receiver, demodulation and acquisition racks illustrate how the downlink becomes a digital stream.',
  },
  {
    site: 'wallops-cdas',
    room: 'room_transport',
    title: 'Hand off to the ground network',
    text: 'Buffered data moves through a terrestrial network interface. The handoff to Suitland is schematic; actual routes and topology are not shown.',
  },
  {
    site: 'suitland',
    room: 'room_ingest',
    title: 'Ingest at Suitland',
    text: 'NSOF ground-system services receive and stage the incoming data. These cabinets are a visual teaching model, not an inventory of the installed systems.',
  },
  {
    site: 'suitland',
    room: 'room_processing',
    title: 'Generate products',
    text: 'Calibration and product-generation services turn observations into environmental products. This room does not assert which services run on site or in the cloud.',
  },
  {
    site: 'suitland',
    room: 'room_operations',
    title: 'Supervise operations',
    text: 'Operator consoles illustrate mission supervision and enterprise management, documented NSOF functions.',
  },
  {
    site: 'suitland',
    room: 'room_distribution',
    title: 'Distribute to users',
    text: 'Product distribution makes the resulting information available to downstream services. The animated route illustrates sequence, not measured traffic.',
  },
] as const;

export const useFacilityTour = create<{
  openAsset: string | null;
  step: number | null;
  setOpenAsset: (id: string | null) => void;
  setStep: (step: number | null) => void;
}>((set) => ({
  openAsset: null,
  step: null,
  setOpenAsset: (openAsset) => set({ openAsset }),
  setStep: (step) => set({ step }),
}));
